import { render, staticRenderFns } from "./FoodcourtPedido.vue?vue&type=template&id=1d56cd28"
import script from "./FoodcourtPedido.vue?vue&type=script&lang=js"
export * from "./FoodcourtPedido.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtPedido.vue?vue&type=style&index=0&id=1d56cd28&prod&lang=scss"
import style1 from "./FoodcourtPedido.vue?vue&type=style&index=1&id=1d56cd28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports